import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { Box, Button, DataTable } from '../../../../common/components';
import { applyFilter } from '../../../../common/components/DataTable/redux/dataTableActions';
import './styles.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../redux/contentActions';
import { InternalButtonBar } from '../../../layout/components';
import formatDateTime from '../../../../helpers/formatDateTime';

class Brochure extends Component {
  constructor(props) {
    super(props);
    this.handleRender = this.handleRender.bind(this);
  }

  handleRowClick(row) {
    this.props.dispatch(push('/admin/content/' + row.id));
  }

  handleRender() {
    return (
      <div>
        <Box>
          <div className="row no-bottom-margin">
            <div className="col-sm-5">
              <ControlLabel className="filter-label">Search</ControlLabel>
              <FormControl onChange={::this.handleSearchUpdate} disabled />
            </div>
            <div className="col-sm-3">
              <ControlLabel className="filter-label">Type</ControlLabel>
              {this.customSelection()}
            </div>
          </div>
        </Box>
      </div>
    );
  }

  handleSearchUpdate(event) {
    this.props.dispatch(applyFilter('content', 'filter[name]', event.target.value));
  }

  handleNewContent = () => {
    const { router, actions } = this.props;
    //actions.newArticleContent(true);
    actions.getTemplate('article');
    router.push('/admin/content/new');
  };

  render() {
    const { isBlogArticles } = this.props;
    const filterValue = isBlogArticles
      ? 'article'
      : 'brand-page,basic-page,basic-page-with-button,questions-page,contact-us,partner-page,privacy-page';

    return (
      <Box>
        <Row className="filter-container">
          <Col sm={5}>
            <ControlLabel>Search</ControlLabel>
            <FormControl onChange={::this.handleSearchUpdate} />
          </Col>
        </Row>

        <DataTable
          source="/contents"
          name="content"
          showTotal
          onRowSelect={this.handleRowClick.bind(this)}
          autoFilters={[{ type: 'filter[template.key]', value: filterValue }]}
        >
          <TableHeaderColumn dataField="id" isKey hidden />

          <TableHeaderColumn dataField="name" dataSort>
            Name
          </TableHeaderColumn>

          <TableHeaderColumn dataField="content_type" dataSort width={'180px'}>
            Type
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="created_at"
            dataSort
            dataFormat={formatDateTime}
            width={'180px'}
          >
            Created
          </TableHeaderColumn>
        </DataTable>

        {isBlogArticles && (
          <Row>
            <Col sm={12}>
              <InternalButtonBar
                buttons={[
                  {
                    permissions: ['content_management.create'],
                    button: (
                      <Button
                        className="pull-right"
                        bsStyle="primary"
                        handleClick={this.handleNewContent}
                        label="new article"
                      />
                    ),
                  },
                ]}
              />
            </Col>
          </Row>
        )}
      </Box>
    );
  }
}

export default connect(
  null,
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(Brochure);
